export default function downloadJson(filename, json) {
  const dataStr =
    'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(json, null, 2));
  const anchorElement = document.getElementById('download_anchor');
  anchorElement.setAttribute('href', dataStr);
  anchorElement.setAttribute('download', filename);
  anchorElement.click();
}
